import Modal from './src/instance'

Modal.install = (app) => {
  app.config.globalProperties['$modal'] = Modal
  app.component(Modal.name, Modal)
}

export const SgModal = Modal
export default SgModal

export * from './src/use-modal'
export * from './src/modal'
export * from './src/constants'
